import { Validator } from '@vista-digital/validator';
import { NumberInputType } from '../../../form/input/number/types/type';
import { itemModalConfigValidatorSchema, itemModalQuantityLimitValidatorSchema } from '../../../item-modal/types/config';
import { defaultItemPickerItemButtonConfig, itemPickerItemButtonConfigValidator } from './item-button-config';
import { ItemPickerMode } from './item-picker-mode';
import { defaultItemPickerNormalItemModifiersConfig, itemPickerNormalItemModifiersConfigValidator } from './normal-item-modifiers-config';
import { defaultItemPickerParentSalesItemOptionsConfig, itemPickerParentSalesItemOptionsConfigValidator } from './parent-sales-item-options-config';
import { defaultItemPickerTabsConfig, itemPickerTabsConfigValidator } from './tabs-config';
/**
 * Default config for the Item Picker component.
 */
export const defaultItemPickerConfig = {
    mode: ItemPickerMode.Tabs,
    readonly: false,
    itemButton: defaultItemPickerItemButtonConfig,
    parentSalesItemOptions: defaultItemPickerParentSalesItemOptionsConfig,
    normalItemModifiers: defaultItemPickerNormalItemModifiersConfig,
    tabs: defaultItemPickerTabsConfig,
    minimumRequiredItems: 0,
    quantityInputType: NumberInputType.Spinner,
    quantityLimit: {
        isUnlimited: true,
        minimum: 1
    }
};
export const itemPickerConfigValidator = Validator.object(Object.assign(Object.assign({}, itemModalConfigValidatorSchema), { mode: Validator.oneOf(Object.values(ItemPickerMode)), readonly: Validator.boolean(), itemButton: itemPickerItemButtonConfigValidator, parentSalesItemOptions: itemPickerParentSalesItemOptionsConfigValidator, normalItemModifiers: itemPickerNormalItemModifiersConfigValidator, tabs: itemPickerTabsConfigValidator, minimumRequiredItems: Validator.number({ min: 0 }), itemProfilePageFilterFn: Validator.optional(Validator.fn()), quantityLimit: Validator.object(Object.assign(Object.assign({}, itemModalQuantityLimitValidatorSchema), { minimum: Validator.number({ min: 1 }) })) }));
